module.exports = __webpack_public_path__ + "img/illustration-not-found.e7103ac3.svg";